<template>
<Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="shuttle_frame_one" width="700">
    <div class="shuttle_left_one">
        <div class="font_style_set_one">
            图标列表</div>
        <ul class="popupul">
            <li v-for="(item,index) in leftData" :key="index+'left'" @mouseenter="entersA(item.id)" @mouseleave="leaverA(item.id)">{{item.activeClass}}
                <span v-show="ifShowA  && item.id === ifShowAId" @click="moveToRight(item.activeClass,item.id,item.level)" class="setposi">右移显示</span>
                <div style="clear:both"></div>
            </li>
        </ul>
    </div>
    <div class="shuttle_right_one">
        <div class="font_style_set_one">位置与宽度</div>
        <ul class="popupul">
            <li v-for="(item,index) in rightData" :key="index+'right'" @mouseenter="entersB(item.id)" @mouseleave="leaverB(item.id)">
                <span>{{item.activeClass}}<span v-if="item.activeClass != undefined && item.activeClass.length<5">&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                <Select v-model="item.level" size="small" style="width:100px;">
                    <Option v-for="option in levelList" :value="option.id" :key="option.id">{{ option.value }}</Option>
                </Select>
                <InputNumber :min="6" :max="24" :activeClass="item.id" v-model="item.span" size="small" :editable="false" class="share_input_one" />
                <span v-show="ifShowB && item.id === ifShowBId" @click="moveToLeft(item.activeClass,item.id,item.level)" class="setposi">左移隐藏</span>
                <div style="clear:both"></div>
            </li>
        </ul>

    </div>
    <div style="text-align:right;">
        <Button type="primary" class="submit_btn" @click="save()" style="display:inline-block;width:60px">确认</Button>
        <Button type="error" class="cancel_btn" @click="cancel()" style="display:inline-block;width:60px">取消</Button>
    </div>
</Modal>
</template>

<script>
import {
    publicFunClass
} from '@/components/js/PublicFunClass.js'
export default {
    mixins: [publicFunClass],
    props: {
        showBigScreenOne: Boolean,
    },
    data() {
        return {
            moveCount: 0,
            id: '',
            ifShowA: false,
            ifShowAId: '',
            ifShowB: false,
            ifShowBId: '',
            leftData: [{
                    id: '1',
                    activeClass: '通话趋势',
                    level: '0',
                    span: 15
                }, {
                    id: '2',
                    activeClass: '话务分析',
                    level: '0',
                    span: 9
                },
                {
                    id: '3',
                    activeClass: '座席状态',
                    level: '1',
                    span: 7
                }, {
                    id: '4',
                    activeClass: '技能组统计',
                    level: '1',
                    span: 10
                }, {
                    id: '5',
                    activeClass: '满意度评价',
                    level: '1',
                    span: 7
                }
            ],
            initTargetData: [],
            initLeftData: [],
            rightData: [],
            shuttleRightList: [],
            shuttleLeftList: [],
            leftAll: false,
            model: false,
            spinShow: true,
            shareValue: '',
            journalType: '',
            menuIdL: '',
            title: '',
            modelHeight: {
                'maxHeight': '',
                'marginTop': '20px'
            },
            baseUploadUrl: "",
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            levelList: [{
                id: '0',
                value: '上方'
            }, {
                id: '1',
                value: '下方'
            }]
        }
    },
    methods: {
        entersA(index) {
            this.ifShowA = true;
            this.ifShowAId = index;
        },
        leaverA(index) {
            this.ifShowAId = '';
            this.ifShowA = false;
        },
        entersB(index) {
            this.ifShowB = true;
            this.ifShowBId = index;
        },
        leaverB(index) {
            this.ifShowB = false;
            this.ifShowBId = '';
        },

        moveToRight(activeClass, id, level) {
            let that = this;
            for (let i = 0; i < that.leftData.length; i++) {
                if (that.leftData[i].id === id) {
                    that.leftData.splice(i, 1);
                    let param = {
                        id: id,
                        span: 6,
                        activeClass: activeClass,
                        level: level,
                    }
                    if (id === '1') { //通话趋势
                        param.span = 15;
                        param.level = '0';
                    } else if (id === '2') { //话务统计
                        param.span = 9;
                        param.level = '0';
                    } else if (id === '3') { //座席状态
                        param.span = 7;
                        param.level = '1';
                    } else if (id === '4') { //技能组
                        param.span = 10;
                        param.level = '1';
                    } else if (id === '5') { //满意度
                        param.span = 7;
                        param.level = '1';
                    }
                    that.rightData.push(param);
                }
            }
        },

        moveToLeft(activeClass, id, level) {

            let that = this;
            for (let i = 0; i < that.rightData.length; i++) {
                if (that.rightData[i].id === id) {
                    that.rightData.splice(i, 1);
                    let param = {
                        id: id,
                        span: 10,
                        activeClass: activeClass,
                        level: level,
                    }
                    that.leftData.push(param);
                }
            }
        },
        save() {
            let that = this;

            this.$Modal.confirm({
                title: '提示',
                content: "是否保存当前修改",
                onOk: () => {

                    let configValue = [];
                    let itemTopValue = "";
                    let itemBottomValue = "";
                    let itemTop = [];
                    let itemBottom = [];
                    for (let m = 0; m < that.rightData.length; m++) {
                        let id = that.rightData[m].id;
                        let type = "";
                        if (id === '1') { // 通话趋势
                            name = "panel1";
                            type = "callTrend";
                        } else if (id === '3') { //座席状态
                            name = "panel3";
                            type = "agentStatus";
                        } else if (id == '4') { //技能组
                            name = "panel4";
                            type = "skillGroup";
                        } else if (id === '5') { //满意度
                            name = "panel5";
                            type = "satisfaction";
                        } else if (id === '2') { //话务分析
                            name = "panel2";
                            type = "trafficAnalysis";
                        }
                        if (that.rightData[m].level == '0') {
                            let param = {
                                span: that.rightData[m].span,
                                pull: '',
                                push: '',
                                activeClass: name,
                                echartType: type
                            }
                            if (itemTopValue) {
                                itemTopValue = itemTopValue + "_" + that.rightData[m].span;
                            } else {
                                itemTopValue = itemTopValue + that.rightData[m].span;
                            }
                            itemTop.push(param);
                        }
                        if (that.rightData[m].level == '1') {
                            let param = {
                                span: that.rightData[m].span,
                                pull: '',
                                push: '',
                                activeClass: name,
                                echartType: type
                            }
                            if (itemBottomValue) {
                                itemBottomValue = itemBottomValue + "_" + that.rightData[m].span;
                            } else {
                                itemBottomValue = itemBottomValue + that.rightData[m].span;
                            }

                            itemBottom.push(param);
                        }
                    }
                    let paramOne = {
                        itemTop: itemTop,
                        itemBottom: itemBottom,
                        itemTopValue: itemTopValue,
                        itemBottomValue: itemBottomValue
                    }
                    configValue.push(paramOne);
                    let param = {
                        id: that.id,
                        configValue: configValue,
                        type: 'callView',
                        journalType: "大屏展示=>通话总览=>设置",
                        menuId: "8_5-1"
                    };
                    that.$http.post("bigScreen/doSave.json", param).then(function (res) {
                        let result = res.data.flag;
                        if (result != "666") {
                            that.$alert(res.data.msg, '提示', {
                                confirmButtonText: '确定'
                            });
                            return false;
                        }
                        that.$emit("closeBigScreenOne", false);
                        that.$Message.info("通话总览大屏设置成功");

                    });
                }
            });
        },
        cancel: function () {
            if (this.moveCount == 0) {
                this.$emit("closeBigScreenOne", false);
                return false;
            }
            let that = this;
            this.$emit("closeBigScreenOne", false);
        },

        initSearch: function () {
            let that = this;
            let param = {
                type: 'callView'
            }
            that.$http.post('bigScreen/toBigScreenIndex.json', param).then(function (res) {
                let result = res.data.flag;
                if (result != "666") {
                    that.$alert(res.data.msg, '提示', {
                        confirmButtonText: '确定'
                    });
                    return false;
                }
                let list = res.data.obj.configDesign;
                that.id = list.id;
                let value = JSON.parse(list.value);
                let itemTop = value.itemTop;
                let itemBottom = value.itemBottom;
                // 给右边数据赋值
                that.rightData.splice(0, that.rightData.length); //清空右边数据，避免重复
                for (let i = 0; i < itemTop.length; i++) {
                    let name = itemTop[i].activeClass;
                    let id = '';
                    if (name == 'panel1') {
                        name = "通话趋势";
                        id = '1';
                    } else if (name == 'panel3') {
                        name = "座席状态";
                        id = '3';
                    } else if (name == 'panel4') {
                        name = "技能组统计";
                        id = '4';
                    } else if (name == 'panel5') {
                        name = "满意度评价";
                        id = '5';
                    } else if (name == 'panel2') {
                        name = "话务分析";
                        id = '2';
                    }
                    let param = {
                        id: id,
                        level: '0',
                        span: parseInt(itemTop[i].span),
                        activeClass: name,
                    };
                    that.rightData.push(param);
                }
                for (let i = 0; i < itemBottom.length; i++) {
                    let name = itemBottom[i].activeClass;
                    let id = '';
                    if (name == 'panel1') {
                        name = "通话趋势";
                        id = '1';
                    } else if (name == 'panel3') {
                        name = "座席状态";
                        id = '3';
                    } else if (name == 'panel4') {
                        name = "技能组统计";
                        id = '4';
                    } else if (name == 'panel5') {
                        name = "满意度评价";
                        id = '5';
                    } else if (name == 'panel2') {
                        name = "话务分析";
                        id = '2';
                    }
                    let param = {
                        id: id,
                        level: '1',
                        span: parseInt(itemBottom[i].span),
                        activeClass: name,
                    };
                    that.rightData.push(param);
                }
                let newList = [];
                // 给左边数据赋值，从全部里面去除右边的数据
                for (let k = 0; k < that.leftData.length; k++) {
                    let flag = true;
                    for (let i = 0; i < that.rightData.length; i++) {
                        if (that.rightData[i].id == that.leftData[k].id) {
                            flag = false;
                        }
                    }
                    if (flag) {
                        newList.push(that.leftData[k]);
                    }
                }
                that.leftData = newList;
            });
        },
    },
    watch: {
        showBigScreenOne: function () {
            this.model = this.showBigScreenOne;
            if (this.showBigScreenOne) {
                this.spinShow = true;
                this.title = '编辑通话总览';

                this.initSearch();
            }
        }
    }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/daping.less";
</style>



// WEBPACK FOOTER //
// src/components/bigScreen/BigScreenOnePop.vue